import script from "./LoadingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingPage.vue?vue&type=style&index=0&id=aecf34f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aecf34f6"]])

export default __exports__